import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationCandidatesController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationCandidatesController.php
* @route '/api/batch-operations/candidates'
*/
const GetBatchOperationCandidatesController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetBatchOperationCandidatesController.url(options),
    method: 'post',
})

GetBatchOperationCandidatesController.definition = {
    methods: ["post"],
    url: '/api/batch-operations/candidates',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationCandidatesController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationCandidatesController.php
* @route '/api/batch-operations/candidates'
*/
GetBatchOperationCandidatesController.url = (options?: RouteQueryOptions) => {
    return GetBatchOperationCandidatesController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationCandidatesController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationCandidatesController.php
* @route '/api/batch-operations/candidates'
*/
GetBatchOperationCandidatesController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetBatchOperationCandidatesController.url(options),
    method: 'post',
})

export default GetBatchOperationCandidatesController